module.exports = __webpack_public_path__ + "static/signature-54771e9ced2375cb1c37780a53c46326.png";